import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Eshop } from 'src/typings';
import { CreateComponent } from '../create/create.component';
import { EshopService } from '../eshop.service';

@Component({
  selector: 'app-eshop-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent {
  eshops: Eshop[] = [];

  @Input() control = new UntypedFormControl();

  constructor(private eshopService: EshopService, private dialog: MatDialog) {
    this.load();
  }

  async load() {
    const res = await firstValueFrom(this.eshopService.search());
    this.eshops = res.data;
  }

  create() {
    const dialogRef = this.dialog.open(CreateComponent);
    dialogRef.componentInstance.doneEvent.subscribe(() => {
      dialogRef.close();
      this.load();
    });
  }
}
